import React from "react";
import Footer from "../components/footer/footer";
import Navbar from "../components/navbar/Navbar";

function PrivacyPage(props) {
  return (
    <div>
      <div className="nav_container">
        <Navbar fromPage="privacypage" />
      </div>
      <div className="bg_img_blog">
        <section className="main_blog_view_container">
          <div className="blog_view_section_under_contianer">
            <div className="terms_container">
              <div className="head">
                <div className="head">
                  <div className="head">
                    <h2>Privacy policy:</h2>
                  </div>
                  <div>
                    <p>
                      Dynamic World Education Community is rendering services to
                      assist students in realizing dreams to pursue a degree of
                      their choice by helping them in discovering, counseling
                      for shortlisting courses and colleges, application
                      assistance, visa assistance, loan assistance, job
                      assistance, English testing, and training, organizing
                      webinars and seminars.
                    </p>
                    <p>
                      If you enquire about study opportunities directly through
                      our website, microsite, blogs, promotional landing pages,
                      counselor and use our services, or we assist you together
                      with your application to review, we can also request
                      additional information like educational qualifications,
                      employment history, occupation, areas of interest and
                      professional memberships, proof of identity &ndash;
                      passport copy, Adhar Card/ PAN, and your funding plan your
                      studies. We may require sensitive information on your
                      ethnic origin (from information on your country of
                      origin), and/or your health or medical information (e.g.
                      from a checkup required for your visa application.
                    </p>
                    <h3>What information can we collect for our benefit?</h3>
                    <p>
                      We are collecting information to provide services. We'd
                      need your name, email id., and other personal information
                      once you register to use certain features of our website
                      or during contests or other promotions sponsored by us
                      and/or our partners.
                    </p>
                    <h4>The collected information will be used:</h4>
                    <p>
                      assisting you to undertake studies during a foreign
                      institution outside India/ Home country.
                    </p>
                    <p>
                      providing you with all relevant information on foreign
                      institutions.
                    </p>
                    <p>
                      Showcasing you as an aspiring candidate to the foreign
                      institutions which are seeking to recruit international
                      students for studying, live, and work there.
                    </p>
                    <p>
                      matching profile to courses in your preferred
                      institutions.
                    </p>
                    <p>
                      assisting you to shape your career after completing your
                      studies.
                    </p>
                    <p>
                      providing opportunities to participate in
                      projects/programs.
                    </p>
                    <p>
                      providing opportunities like reference checks and
                      testimonials on your experience.
                    </p>
                    <p>
                      informing you on institutions and therefore the services
                      we offer (including events
                    </p>
                    <p>
                      and opportunities to participate in projects/programs).
                    </p>
                    <p>
                      conducting research for statistical, analytical, and
                      training purposes.
                    </p>
                    <p>
                      managing DWEC&rsquo;s internal business operations and
                      events.
                    </p>
                    <h3>Cookies:</h3>
                    <p>
                      We may send and store (time-bound) cookies (small files
                      containing a string of characters) uniquely identifying
                      your browser. Cookies are tracked to know your
                      preferences, assist you to log in faster, and aggregate
                      for user trends. This data is employed to enhance our
                      offerings, like providing more content in areas of greater
                      interest to a majority of users. Most browsers are
                      initially found out to simply accept cookies, but you'll
                      reset your browser to refuse all cookies or to point when
                      a cookie is being sent. A number of our features and
                      services might not function properly if your cookies are
                      disabled.
                    </p>
                    <h3>Log Information:</h3>
                    <p>
                      When you access our website, our servers, and CRM
                      automatically record information that your browser sends
                      whenever you visit an internet site. These server logs may
                      include information like your web request, Internet
                      Protocol address, browser type, browser language, the date
                      and time of your request, and one or more cookies which
                      will uniquely identify your browser.
                    </p>
                    <h3>User Communications:</h3>
                    <p>
                      When you send an email or other communication to us, we
                      may retain those communications so as to process your
                      inquiries, answer your requests and improve our services.
                    </p>
                    <h3>Links:</h3>
                    <p>
                      We may present links to permit us to track these links
                      that are followed. We use this information to enhance our
                      customized content. Clicking on links may take you to
                      sites outside our domain. We aren't liable for the privacy
                      practices of other websites. We encourage our users to
                      remember once they leave our site to read the privacy
                      statements of every website that collects personally
                      identifiable information. This Privacy Policy applies
                      solely to information collected by our Website.
                    </p>
                    <h3>Alerts:</h3>
                    <p>
                      We may notify you (through SMS/call/WhatsApp)about new
                      service offerings or other information which we feel could
                      be useful for you.
                    </p>
                    <h3>Public Forums:</h3>
                    <p>
                      When you use certain features on our website just like the
                      discussion forums and you post or share your personal
                      information like comments, messages, files, photos, are
                      going to be available to all users and can be within the
                      property right. All such sharing of data is completed at
                      your own risk. Please note if you disclose personal
                      information in your profile or when posting on our forums
                      this information may become publicly available.
                    </p>
                    <h3>Data Security:</h3>
                    <p>
                      If you employ a feature requiring payment of a fee, we
                      transmit your credit card data to our bank for processing.
                      If we encounter a problem with payment, we may review the
                      order information with you and our bank to resolve it (to
                      know more read our separate T&amp;C on payment and
                      refund). We don't otherwise disclose you credit card
                      information. We do not share your email address or your
                      personal information with third-party players/ marketers.
                    </p>
                    <p>
                      We offer secure assets to collect sensitive information on
                      forms, including credit card information. While no
                      computing system is totally secure, we believe the
                      measures implemented by our Site/payment partners reduce
                      the likelihood of security problems to the appropriate
                      level of the data involved.
                    </p>
                    <p>
                      We use reasonable technical, administrative, and physical
                      security measures for the aim of safeguarding all data you
                      share with us. We even have comprehensive internal
                      policies in situ to stop unauthorized access to your data.
                      We take adequate steps to ensure that third parties we
                      share data with also adopt a reasonable level of security
                      practices and procedures to ensure the privacy and
                      security of your information.
                    </p>
                    <p>
                      However, we aren't liable for any loss, unauthorized
                      access, safety issue, or any harm caused to you by any
                      misuse of your personal information, unless it's an
                      immediate and foreseeable consequence of negligence and
                      non-compliance on our part only. You hereby acknowledge
                      that we aren't responsible, especially, for any third
                      party action or action on your part resulting in loss,
                      damage, or harm to you or any other person.
                    </p>
                    <p>
                      DWEC shall not be held liable for any loss whatsoever
                      incurred by you, due to unauthorized access to your
                      electronic devices.
                    </p>
                    <h3>Information Sharing:</h3>
                    <p>
                      Other than the above-mentioned sharing of knowledge
                      associated with credit card information, we only share
                      personal information with other companies or individuals
                      outside of Dynamic World Education Community Private
                      Limited within the following circumstances only:
                    </p>
                    <p>
                      A. Satisfy any applicable law, regulation, legal process,
                      or enforceable governmental request. B. Enforce applicable
                      Terms of Use, including investigation of potential
                      violations thereof. C. Detect, prevent, or otherwise
                      address fraud, security, or technical issues. D. Protect
                      against imminent harm to the rights, property, or safety
                      of Dynamic World Education Community Private Limited, its
                      users, or the general public as needed or permitted by
                      law. We may share with third parties certain pieces of
                      aggregated, non-personal information, like the number of
                      users subscribed to a specific product, or the number of
                      users registered on our website. Such information doesn't
                      identify you individually. E. By using the website and/or
                      registering yourself with us you give us the proper to
                      contact you via email or call or SMS and provide you with
                      our services, imparting product knowledge, offer
                      promotional offers running on website &amp; offers offered
                      by third parties, that reasons, personally identifiable
                      information could also be collected. And regardless of the
                      very fact if you've got also registered yourself under DND
                      or DNC or NCPR service, you continue to authorize us to
                      offer you the above-mentioned purposes till three hundred
                      and sixty-five days of your registration with us.
                    </p>
                    <h3>Student Essentials Services:</h3>
                    <p>
                      DWEC offers services from foreign institutions, third
                      parties to assist you in your overseas studies, and we
                      call these DWEC Services Essentials (uploaded here). These
                      services include accommodation arrangements, referral to
                      guardianship services, visa application services, and
                      career skills training among others.
                    </p>
                    <p>
                      If you avail and buy Services Essentials we track the
                      online pages, and knowledge that has been accessed by you,
                      and store it on our servers located in India. this permits
                      us to trace items that you simply have completed and
                      people that you got to see.
                    </p>
                    <p>
                      We may collect payment information; however, DWEC doesn't
                      store information like credit card details.
                    </p>
                    <p>Visa application services:</p>
                    <p>
                      DWEC provides visa application services for visas guiding
                      you thru the appliance process and helping you prepare the
                      required documents for your nominated visa application.
                      These visa application services not only cover visa
                      applications required for study but also post-study work
                      and skilled migration visa applications.
                    </p>
                    <p>
                      Collection of your personal information and sensitive
                      information (such as information from your medical
                      examination) allows us to:
                    </p>
                    <p>
                      &bull; assist you in your application for a student visa
                      including contacting the Department of Home Affairs (DHA)
                      and other organizations on your behalf to debate your
                      application.
                    </p>
                    <p>
                      &bull; provide the Department of Home Affairs (DHA) with
                      all relevant information required for your visa
                      application.
                    </p>
                    <p>
                      &bull; contact the DHA or other organizations on your
                      behalf to debate or ask questions on your visa
                      application.
                    </p>
                    <p>
                      &bull; keep you updated with the progress of your visa
                      application and advise you of the result of your
                      application.
                    </p>
                    <h3>Retention</h3>
                    <p>
                      DWEC vision is to create and nurture a community of
                      connected students beyond classrooms and blackboards. This
                      suggests we might wish to stay in-tuned for as long as you
                      think that appropriate, but we'll only retain your
                      information as long as is important for the aim it had
                      been given to us.
                    </p>
                    <p>
                      As an organization, we shall store your personal
                      information up to five years after commencing your studies
                      or your last activity with us in order that we will still
                      support you thru your journey unless required to retain it
                      for legal or regulatory purposes.
                    </p>
                    <h4>Why are we collecting Personal Information?</h4>
                    <p>
                      We collect personal information from you to gather the
                      knowledge required to service you, and to assist us to
                      deliver a superior career enhancement experience.
                      Information collected enables us to offer you convenient
                      access to our service offerings and products and should
                      help us tailor your career experience.
                    </p>
                    <h3>Grievances:</h3>
                    <p>
                      If you've got any grievances on the usage of any of your
                      personal information or the other privacy concerns, you'll
                      contact the Grievance Officer whose details are provided
                      below: marketing@dynamicwec.net
                    </p>
                    <h3>Disclaimer:</h3>
                    <p>
                      The information contained on this website is for general
                      information purposes only. the knowledge is provided by
                      Dynamic World Education Community Private Limited and
                      while we endeavor to stay the knowledge up so far and
                      proper, we make no representations or warranties of any
                      kind, express or implied, about the completeness,
                      accuracy, reliability, suitability, or availability with
                      reference to the web site or the knowledge, products,
                      services, or related graphics contained on the web site
                      for any purpose. Any reliance you place on such
                      information is therefore strictly at your own risk.
                    </p>
                    <p>
                      In no event will we be responsible for any loss or damage
                      including without limitation, indirect or consequential
                      loss or damage, or any loss or damage whatsoever arising
                      from loss of knowledge or profits arising out of, or in
                      reference to, the utilization of this website.
                    </p>
                    <p>
                      Through this website/ you're ready to link to other
                      websites which aren't under the control of Dynamic World
                      Education Community Private Limited. we've no control over
                      the character, content, and availability of these sites.
                      The inclusion of any links doesn't necessarily imply a
                      recommendation or endorse the views expressed within them.
                    </p>
                    <p>
                      Every effort is formed to stay the website up and running
                      smoothly. However, Dynamic World Education Community
                      Private Limited takes no responsibility for, and cannot be
                      responsible for, the website being temporarily unavailable
                      thanks to technical issues beyond our control.
                    </p>
                    <h3>Data Deletion</h3>
                    <p>
                      You can send your data deletion request to us through
                      email. so as to urge your data deleted from our servers,
                      send an email to marketing@dynamicwec.net with the topic
                      "Data Deletion ".
                    </p>
                    <h3>Grievance Redressal</h3>
                    <p>
                      1. In compliance with the provisions of the knowledge and
                      Technology Act, 2005 (&ldquo;IT Act&rdquo;), to deal with
                      your concerns concerning the usage of your user data,
                      you'll contact us at marketing@dynamicwec.net
                    </p>
                    <p>
                      2. within the event, you've got any complaints or concerns
                      regarding the usage of your user data, you'll write to us
                      electronically at marketing@dynamicwec.net or send a
                      letter to us at:
                    </p>
                    <address>
                      World Education Community Private Limited, A-3/5, BIDC,
                      Gorwa, Vadodara &ndash; 390 016, Gujarat
                    </address>
                    <p>&nbsp;</p>
                    <p>
                      3. Within 24 (twenty-four) hours of the receipt of your
                      email, we'll acknowledge your email and shall eliminate an
                      equivalent within 15 (fifteen) days of the receipt of your
                      email, upon conducting hearings and discussions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPage;
